module.exports = __webpack_public_path__ + "static/media/and.db964c97.svg";